import React, { Component } from 'react';
import authService from './../api-authorization/AuthorizeService'
import { ConfigMenu } from './../ConfigMenu'

export class ConfigUsers extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      users: [],
      globalUsers: [],
      requests: [],
      globalUserId: 0,
      resources: [],
      loading: true,
      selectedUser: null,
      userFilter: '',
      companyId: parseInt(this.props.match.params.companyId) || 0
    };
    this.handleAdd = this.handleAdd.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    if (this.state.companyId === 0)
      this.populateCompaniesData();
    else {
      this.populateCompanyData();
      this.populateUsersData(this.state.companyId);
      this.populateResourcesData(this.state.companyId);
    }
    this.populateRequestedUsersData();
  }

  selectGlobalUser(userId) {
    this.setState(prevState => ({...prevState, globalUserId: userId, user: null}));
    var users = this.state.users.filter(u => u.identityId === userId);
    this.setState(prevState => ({...prevState, selectedUser: users.length > 0 ? users[0] : null}));
  }

  async handleAdd() {
    /*const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/users/${this.state.globalUserId}`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    const data = await response.json();
    if (data) {
      this.setState(prevState => ({...prevState, users: [...prevState.users, data]}));
      this.selectGlobalUser(this.state.globalUserId);
    }*/
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{userApiUrl}}api/users/request`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({userId: this.state.globalUserId, companyId: this.state.companyId, companyName: this.state.companyName})
    });
    const data = await response.json();
    const requests = this.state.requests;
    requests.push(data);
    this.setState(prevState => ({...prevState, requests: requests}));
  }

  async handleSave() {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/users/${this.state.globalUserId}?admin=${this.state.selectedUser.admin}&resourceId=${this.state.selectedUser.resourceId===null?0:this.state.selectedUser.resourceId}`, {
      method: "PUT",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    await response.json();
    var users = this.state.users;
    for (var i = 0; i < users.length; i++)
    {
      if (users[i].identityId === this.state.selectedUser.identityId)
      {
        users[i] = this.state.selectedUser;
        break;
      }
    }
    this.setState(prevState => ({...prevState, users: users}));
  }

  async handleDelete(identityId) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/users/${identityId}`, {
      method: "DELETE",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    await response.json();
    var users = this.state.users.filter(d => d.identityId !== identityId);
    this.setState(prevState => ({...prevState, users: users}));
    if (this.state.globalUserId === identityId)
      this.setState(prevState => ({...prevState, selectedUser: null}));
  }

  renderUsersTable() {
    return (
      <><div class="tablediv">

        <table className='table table-striped' aria-labelledby="tabelLabel">
          <thead>
            <tr>
              <th>Name</th>
              <th>Admin</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {this.state.users.map(user =>
              <tr key={user.id} onClick={() => this.selectGlobalUser(user.identityId)} class={this.state.globalUserId === user.identityId?'react-calendar__tile--active':''}>
                <td>{user.firstName} {user.lastName}</td>
                <td>{user.admin?'+':''}</td>
                <td><a onClick={() => this.handleDelete(user.identityId)}>Delete</a></td>
              </tr>
            )}
          </tbody>
        </table>

      </div>
        {this.state.selectedUser !== null ? (
        <><div>
          <label for="Input_Admin">Admin</label>
          <input class="form-check-input" type="checkbox" id="Input_Admin" name="Input.Admin"
            checked={this.state.selectedUser.admin}
            onChange={evt => {const val = evt.target.checked; this.setState(prevState => ({...prevState, selectedUser: {...prevState.selectedUser, admin: val}}));}}/>
        </div>
        <div class="form-group">
          <label for="Input_Resource">Assigned resource</label>
          <select class="form-control" id="Input_Resource" name="Input.Resource"
            value={this.state.selectedUser.resourceId ? this.state.selectedUser.resourceId.toString() : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, selectedUser: {...prevState.selectedUser, resourceId: val}}));}}>
            <option value="0"></option>
            {this.state.resources.map(resource =>
              <option value={resource.id}>{resource.name}</option>
            )}
          </select>
        </div>
        <input style={{marginTop: "5px"}} class="btn btn-primary" type="button" value="Save" id="Button_Add" onClick={this.handleSave}/>
        </>
        ) : (<></>)}
      </>
    );
  }

  renderRequestedUsersTable() {
    return (
      <>
      <div class="tabledivbig">

      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Requested</th>
          </tr>
        </thead>
        <tbody>
          {this.state.requests.map(req =>
            (<tr key={req.userId} class={this.state.globalUserId === req.userId?'react-calendar__tile--active':''}>
              <td>{req.firstName}</td>
              <td>{req.phone}</td>
              <td>{req.status===0?"Requested":"Declined"}</td>
            </tr>)
          )}
        </tbody>
      </table>

      </div>
      </>
    );
  }

  renderGlobalUsersTable() {
    const globalRequests = this.state.requests.filter(req => req.userId === this.state.globalUserId && req.status === 0);
    const users = this.state.users.filter(req => req.identityId === this.state.globalUserId);
    return (
      <>
      <div class="tabledivbig">
      <div class="tabledivbtn">

      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Requested</th>
          </tr>
        </thead>
        <tbody>
          {this.state.globalUsers.map(user =>
          {
            const req = this.state.requests.filter(req => req.userId === user.id);
            return (<tr key={user.id} onClick={() => this.selectGlobalUser(user.id)} class={this.state.globalUserId === user.id?'react-calendar__tile--active':''}>
              <td>{user.firstName}</td>
              <td>{user.phone}</td>
              <td>{req.length>0?(req[0].status===0?"Requested":"Declined"):""}</td>
            </tr>);
          }
          )}
        </tbody>
      </table>

      </div>
        <input style={{marginTop: "5px"}} class="btn btn-primary" type="button" value="Invite to company" id="Button_Add" disabled={this.state.globalUserId === 0 || globalRequests.length > 0 || users.length > 0} onClick={this.handleAdd}/>
      </div>
      </>
    );
  }

  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderUsersTable();

    return (
      <div class="sidenav-container-div">
        <ConfigMenu {...this.props} companyId={this.state.companyId} selected="users" />
        <h4 id="tabelLabel">Config users</h4>
        <p>Requested users</p>
        {this.renderRequestedUsersTable()}
        <p>Request employees to join the company</p>
        <div>
          <div class="searchimg"><i class="fa-solid fa-magnifying-glass fa-xl"></i></div><input class="form-control searchinput" type="text" id="Input_UserFilter" name="Input.UserFilter"
            value={this.state.userFilter !== undefined ? this.state.userFilter : ''}
            onChange={evt => {const val = evt.target.value; this.populateGlobalUsersData(evt.target.value);}}
          />
        </div>
        {this.renderGlobalUsersTable()}
        <p>Company employees list</p>
        {contents}
      </div>
    );
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (this.state.companies.length > 0)
    {
        this.setState(prevState => ({...prevState, companyId: this.state.companies[0].id, companyName: this.state.companies[0].name}));
        this.populateUsersData(this.state.companyId);
        this.populateResourcesData(this.state.companyId);
    }
  }

  async populateCompanyData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companyName: data.name}));
  }

  async populateResourcesData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/resources`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, resources: data, loading: false}));
  }

  async populateUsersData(companyId) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/${companyId}/users`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, users: data, loading: false}));
  }

  async populateGlobalUsersData(filter) {
    if (filter.length < 4)
    {
      this.setState(prevState => ({...prevState, userFilter: filter, globalUsers: []}));
      return;
    }
    this.setState(prevState => ({...prevState, userFilter: filter}));
    const token = await authService.getAccessToken();
    const response = await fetch(`{{userApiUrl}}api/users?filter=${encodeURIComponent(filter)}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, globalUsers: data}));
  }

  async populateRequestedUsersData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{userApiUrl}}api/users/requests/${this.state.companyId}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, requests: data}));
  }
}
